import { jsx as _jsx } from "react/jsx-runtime";
// web/src/rendering/components/layouts/Row.tsx
// Horizontal flex row of render blocks.
import { Renderer } from "../../Renderer";
const ALIGN = {
    start: "items-start",
    center: "items-center",
    end: "items-end",
    stretch: "items-stretch",
};
const GAP = { 2: "gap-2", 3: "gap-3", 4: "gap-4", 6: "gap-6" };
export function Row({ gap = 4, align = "stretch", children = [] }) {
    return (_jsx("div", { className: `flex flex-row ${GAP[gap] ?? "gap-4"} ${ALIGN[align] ?? "items-stretch"} mt-3`, children: children.map((child, i) => (_jsx("div", { className: "flex-1 min-w-0", children: _jsx(Renderer, { block: child }) }, i))) }));
}
